// //UI Processors
import SingleValueReduxUtil from "src/ui_processors/single_value";

export const storeCurrentUserEmailAction = SingleValueReduxUtil.createActionCreators(
  "currentUserEmail"
);
